"use client";

import { useEffect, useState } from "react";

const LINES = ["Real environments.", "Real attack paths."];
const TYPE_SPEED = 55; // ms per character
const LINE_PAUSE = 320; // ms between lines

export function TerminalHeading() {
  const [currentLine, setCurrentLine] = useState(0);
  const [currentChar, setCurrentChar] = useState(0);
  const [showCursor, setShowCursor] = useState(true);

  // Typing effect
  useEffect(() => {
    if (currentLine >= LINES.length) return;
    const target = LINES[currentLine];
    if (currentChar < target.length) {
      const t = setTimeout(() => setCurrentChar((c) => c + 1), TYPE_SPEED);
      return () => clearTimeout(t);
    }
    const t = setTimeout(() => {
      setCurrentLine((l) => l + 1);
      setCurrentChar(0);
    }, LINE_PAUSE);
    return () => clearTimeout(t);
  }, [currentLine, currentChar]);

  // Cursor blink
  useEffect(() => {
    const t = setInterval(() => setShowCursor((v) => !v), 530);
    return () => clearInterval(t);
  }, []);

  const done = currentLine >= LINES.length;

  return (
    // All lines are always rendered at full size — future lines are invisible so
    // the element never changes height as the animation progresses.
    <h1 className="text-4xl sm:text-5xl font-bold text-cb-text mb-5 leading-[1.15]">
      {LINES.map((line, lineIdx) => {
        const isCompleted = lineIdx < currentLine || done;
        const isCurrent   = !done && lineIdx === currentLine;
        const isVisible   = isCompleted || isCurrent;

        return (
          <span
            key={lineIdx}
            className="flex items-baseline gap-2"
            style={{ visibility: isVisible ? "visible" : "hidden" }}
            aria-hidden={!isVisible}
          >
            <span className="text-cb-blue font-mono text-3xl sm:text-4xl select-none">›</span>
            <span>
              {isCompleted ? line : isCurrent ? line.slice(0, currentChar) : line}
              {/* invisible remainder keeps the row width stable while typing */}
              {isCurrent && currentChar < line.length && (
                <span style={{ visibility: "hidden" }}>{line.slice(currentChar)}</span>
              )}
              {isCurrent && (
                <span
                  className="inline-block w-[3px] h-[0.85em] bg-cb-blue align-middle ml-0.5 relative top-px"
                  style={{ opacity: showCursor ? 1 : 0, transition: "opacity 0.1s" }}
                />
              )}
            </span>
          </span>
        );
      })}
    </h1>
  );
}
